import { render, staticRenderFns } from "./AutorizadorOrdenServicioView.vue?vue&type=template&id=2bb71fdc"
import script from "./AutorizadorOrdenServicioView.vue?vue&type=script&lang=js"
export * from "./AutorizadorOrdenServicioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports